export class PersonalInformationUpdate {

  phoneNumber: string;
  emailAddress: string;

  constructor(phoneNumber: string,
              emailAddress: string) {
    this.phoneNumber = phoneNumber;
    this.emailAddress = emailAddress;
  }
}

